import React from "react";
import { RightPanel } from "../../../../../../components/RightPanel";
import { Coverage } from "./Coverage";
import { IBusinessPolicyCoverage } from "../../../../../../redux/businessPolicy/businessPolicyCoverage/businessPolicyCoverage.types";

interface ICoverageRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  coverageId?: number;
  onSaveSuccess: (data: IBusinessPolicyCoverage) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IBusinessPolicyCoverage;
  disableApiCalls?: boolean;
}

export const CoverageRightPanel: React.FC<ICoverageRightPanelProps> = (
  props
) => {
  const {
    customerId,
    customerPolicyId,
    coverageId,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls
  } = props;

  return (
    <>
      <RightPanel
        heading="Coverage"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="80%"
      >
        <Coverage
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          coverageId={coverageId}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          staticStatusValue={staticStatusValue}
          created_from={created_from}
          disableApiCalls={disableApiCalls}
          initialData={initialData}
        />
      </RightPanel>
    </>
  );
};
